var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 12,
    width: 12,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.715 10.385a.5.5 0 01-.295-.095L6 8.535 3.58 10.29a.5.5 0 01-.77-.56l.925-2.845-2.42-1.755a.5.5 0 01.295-.905h3l.925-2.845A.5.5 0 016 1.035a.5.5 0 01.475.345L7.4 4.225h3a.5.5 0 01.295.905l-2.42 1.755L9.2 9.73a.5.5 0 01-.475.655z",
    fill: "#121314"
  })));
}
export default SvgSmall;